import axios from 'axios';
import { getSessionServerId, getSessionToken } from '@/services/session';

const SOURCE_ID = Number(import.meta.env.VITE_SOURCE_ID || 0);
const API_BASE = String(import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
const SOCIAL_BASE = API_BASE;

function withCommonParams(params = {}) {
  const translation = localStorage.getItem('translation');
  const lang = translation === 'kz' ? 'kk-KZ' : 'ru-RU';
  return {
    ...params,
    source_id: SOURCE_ID,
    'x-lang': lang
  };
}

function withCommonHeaders(headers = {}) {
  const token = getSessionToken();
  const institutionId = getSessionServerId();
  const translation = localStorage.getItem('translation');
  const lang = translation === 'kz' ? 'kk-KZ' : 'ru-RU';

  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(institutionId ? { 'x-server-id': institutionId } : {}),
    'x-lang': lang
  };
}

const socialBase = SOCIAL_BASE;
const profiBase = String(import.meta.env.VITE_PROFIWAY_BASE_URL || '').replace(/\/+$/, '');

export const feedEndpoints = {
  regions: '/dics/regions',
  newsList: '/social/news',
  quizList: '/surveys/surveys',
  quizAnswers: '/surveys/answers',
  halykUserInfo: '/users/user-info/get-token',
  profiwayList: '/survey/index',
  profiwayStart: '/survey/start',
  profiwayAnswer: '/survey/answer',
  profiwayFinish: '/survey/finish'
};

export const socialClient = axios.create({
  baseURL: socialBase
});

socialClient.interceptors.request.use((config) => {
  const next = { ...config };
  next.params = withCommonParams(next.params || {});
  next.headers = withCommonHeaders(next.headers || {});
  if (import.meta.env.DEV) {
    console.debug('[socialClient] auth header exists:', Boolean(next.headers?.Authorization));
  }
  return next;
});

export const profiClient = axios.create({
  baseURL: profiBase
});

profiClient.interceptors.request.use((config) => {
  const next = { ...config };
  next.params = withCommonParams(next.params || {});
  next.headers = withCommonHeaders(next.headers || {});
  if (import.meta.env.DEV) {
    console.debug('[profiClient] auth header exists:', Boolean(next.headers?.Authorization));
  }
  return next;
});

export function unwrapBody(data) {
  if (data && typeof data === 'object' && 'body' in data) {
    return data.body;
  }
  return data;
}
